import { defineComponent as _defineComponent } from 'vue'
import {
  IMonthly,
  IPerformanceYear
} from '@/modules/investments/types/Performance';
import PerformanceHeader from '@/modules/investments/views/Performance/components/PerformanceHeader/PerformanceHeader.vue';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  HeadingDisplay,
  Grid,
  Row,
  StatusColors,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/Money';
import { computed } from 'vue';

interface Props {
  historical: IPerformanceYear;
  benchmarkSelected: string;
  benchmarkComparisonSelected: string;
}

interface Emits {
  (event: 'show-details', value: IMonthly): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PerformanceByYear',
  props: {
    historical: null,
    benchmarkSelected: null,
    benchmarkComparisonSelected: null
  },
  emits: ["show-details"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'show-details', value: IMonthly): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  historical: IPerformanceYear;
  benchmarkSelected: string;
  benchmarkComparisonSelected: string;
};





const headers = computed(() => [
  {
    description: 'Rendimento bruto',
    value: props.historical?.values?.profitValues?.formatted
  },
  {
    description: 'Rentabilidade bruta',
    value: props.historical?.values?.returns?.formatted
  },
  {
    description: props.benchmarkSelected ?? '',
    value: props.historical?.values?.benchmark?.formatted ?? ''
  },
  {
    description: props.benchmarkComparisonSelected ?? '',
    value: props.historical?.values?.benchmarkComparison?.formatted ?? '',
    statusValue: !props.historical?.values?.benchmarkComparison?.isNegative
      ? StatusColors.POSITIVE
      : StatusColors.NEGATIVE
  }
]);

const getBenchmarkComparisonValue = (value: string) => {
  if (!props?.benchmarkSelected) return '';
  return props?.benchmarkSelected === 'CDI'
    ? `${value} do CDI`
    : `${props?.benchmarkComparisonSelected} ${value}`;
};

const handleClick = (value: IMonthly) => {
  if (!value?.values?.isEmpty) {
    emit('show-details', value);
  }
};

return { __sfc: true,props, emit, headers, getBenchmarkComparisonValue, handleClick, PerformanceHeader, NebraskaColors, HeadingDisplay, Grid, Row, BaseText, Money }
}

})